module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ThinItalic.woff?7a27099d900738db94985e5590ecf31c";